import { render, staticRenderFns } from "./power-ups.vue?vue&type=template&id=5c60428f&scoped=true&"
import script from "./power-ups.vue?vue&type=script&lang=js&"
export * from "./power-ups.vue?vue&type=script&lang=js&"
import style0 from "./power-ups.vue?vue&type=style&index=0&id=5c60428f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60428f",
  null
  
)

export default component.exports